import React from 'react';
import EmailForm from './EmailForm';

function Contact() {
  return (
    <div className="p-4 xl:p-8 sm:mx-8 md:mx-10 sm:pt-10 w-full flex flex-col items-center justify-center">
      <h1 className="text-lightGreen font-bold text-2xl lg:text-3xl xl:text-4xl mb-2 md:my-4 2xl:mb-7 self-start">
        Contact
      </h1>
      <p className="text-slate-100 sm:text-lg md:text-xl xl:text-2xl self-start">
        Want to reach out to me? Feel free to send me an email!
      </p>
      <EmailForm />
    </div>
  );
}

export default Contact;
